import React from "react";
import "./portfolio.css";
import IMG1 from "../../assets/portfolio1.png";
import IMG2 from "../../assets/portfolio2.png";
import IMG3 from "../../assets/portfolio3.png";
import IMG4 from "../../assets/portfolio4.png";
import IMG5 from "../../assets/portfolio5.png";
import IMG6 from "../../assets/portfolio6.png";
import IMG7 from "../../assets/portfolio7.png";
import IMG8 from "../../assets/portfolio8.png";
import IMG9 from "../../assets/portfolio9.png";
import IMG10 from "../../assets/portfolio10.png";
import IMG11 from "../../assets/portfolio11.png";
import IMG12 from "../../assets/portfolio12.png";
import IMG13 from "../../assets/portfolio13.png";
import IMG14 from "../../assets/portfolio14.png";
import IMG15 from "../../assets/portfolio15.png";

const data = [
  {
    id: 1,
    image: IMG1,
    title: "BJ Elderly Care Home",
    demo: "https://www.bj-elderlycarehome.com/",
  },
  {
    id: 2,
    image: IMG2,
    title: "Nike clone website",
    github: "https://github.com/iyanuxn/nike",
    demo: "https://iyanuxn.github.io/nike",
  },
  {
    id: 3,
    image: IMG3,
    title: "Todo App",
    github: "https://github.com/iyanuxn/Todo-app",
  },
  {
    id: 4,
    image: IMG4,
    title: "Minimal portfolio website",
    github: "https://github.com/iyanuxn/portfolio-temp",
    demo: "https://iyanuxn.github.io/portfolio-temp",
  },
  {
    id: 5,
    image: IMG5,
    title: "Shop Landing Page",
    github: "https://github.com/Landing-page",
    demo: "https://iyanuxn.github.io/Landing-page",
  },
  {
    id: 6,
    image: IMG6,
    title: "Charts component",
    github: "https://github.com/charts",
    demo: "https://iyanuxn.github.io/charts",
  },
  {
    id: 7,
    image: IMG7,
    title: "Rating component",
    github: "https://github.com/Rating",
    demo: "https://iyanuxn.github.io/Rating",
  },
  {
    id: 8,
    image: IMG8,
    title: "Email subscription page",
    github: "https://github.com/Ping",
    demo: "https://iyanuxn.github.io/Ping",
  },
  {
    id: 9,
    image: IMG9,
    title: "Random Quotes",
    github: "https://iyanuxn.github.io/reasons-to-live",
    demo: "https://iyanuxn.github.io/reasons-to-live/",
  },
  {
    id: 10,
    image: IMG10,
    title: "Invisible2DGuy",
    github: "https://github.com/iyanuxn/invisible2dguy",
    demo: "https://invisible2dguy.vercel.app/",
  },
  {
    id: 11,
    image: IMG11,
    title: "Where in world",
    github: "https://github.com/iyanuxn/country-details",
    demo: "https://country-details-tawny.vercel.app/",
  },
  {
    id: 12,
    image: IMG12,
    title: "Chesed Books",
    github: "https://github.com/iyanuxn/Chesed",
    demo: "https://chesed.vercel.app/",
  },
  {
    id: 13,
    image: IMG13,
    title: "TRD U.I",
    github: "#",
    demo: "http://trd.ui.edu.ng",
  },
  {
    id: 14,
    image: IMG14,
    title: "Dev Finder",
    github: "https://github.com/iyanuxn/Github-user-search",
    demo: "https://findgithubdev.vercel.app/",
  },
  {
    id: 15,
    image: IMG15,
    title: "IP Finder",
    github: "https://github.com/iyanuxn/ip_finder",
    demo: "https://ip-finder-pi.vercel.app/",
  },
];

const Portfolio = () => {
  const reversedData = [...data].reverse(); // Create a copy of data array and reverse it

  return (
    <section id="portfolio">
      <h5>My Recent Work</h5>
      <h2>Portfolio</h2>
      <div className="container portfolio__container">
        {reversedData.map(({ id, image, title, github, demo }) => {
          return (
            <article key={id} className="portfolio__item">
              <div className="portfolio__item-image">
                <img src={image} alt={title} />
              </div>
              <h3>{title}</h3>
              <div className="portfolio__item-cta">
                <a className="btn" href={github} target="_blank">
                  Github
                </a>
                <a className="btn btn-primary" href={demo} target="_blank">
                  Live Demo
                </a>
              </div>
            </article>
          );
        })}
      </div>
    </section>
  );
};

export default Portfolio;
